import React, { Component } from "react";
import DashboardTableContainer from "./containers/DashboardTableContainer";
import { connect } from "react-redux";
import { dashboardOperations } from "./duck/index";
import { stimsOperations } from "../Stims/duck/index";
import CheckBoxStyled from "../common/components/Checkbox";
import PrettyDropdown2 from "../common/components/PrettyDropDown2";
import PropTypes from "prop-types";
import LoadingSpinner from "../common/components/LoadingSpinner";
//import Modal from './components/Modal';
import ToolTip from "../common/components/Tooltip";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "../common/components/Pagination";
import FormControlLabel from "@mui/material/FormControlLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import FiltersRow from "../components/FiltersRow";



class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      stimsPerPage: 25,
      pageNum: 1,
      orderBy: "id_desc",
      filterName: "",
      filterLive: "-1",
      isCompleted: "-1",
      filterMediaId: 0,
      filterEnvironmentId: 0,
      showMyStudies: false,
      filterPhaseId: -1,
      filterPhaseColourId: -1,
      selectedStudies: [],
      selectAllLoading: false,
      selectAllChecked: false,
      actionsAnchorEl: null,
      bulkConfirmOpen: false,
      bulkConfirm: null,
      bulkSubmitting: false,
      filterPhaseColourSystemProcessingEnabled: "-1",
      filterPhaseColourSystemPausedOverride: "-1",

    };
    this.myTimer = React.createRef(null);
  }

componentDidMount() {
  const savedState = JSON.parse(sessionStorage.getItem("dashboardFilters")) || {};

  this.setState({
    stimsPerPage: savedState.stimsPerPage ?? 25,
    pageNum: savedState.pageNum ?? 1,
    orderBy: savedState.orderBy ?? "id_desc",
    filterName: savedState.filterName ?? "",
    filterLive: savedState.filterLive ?? "-1",
    isCompleted: savedState.isCompleted ?? "-1",
    filterMediaId: savedState.filterMediaId ?? 0,
    filterEnvironmentId: savedState.filterEnvironmentId?? 0,
    showMyStudies: savedState.showMyStudies ?? false,
    showFilter: savedState.showFilter ?? false,  
    filterPhaseId: savedState.filterPhaseId !== undefined
  ? Number(savedState.filterPhaseId): -1,
    filterPhaseColourSystemProcessingEnabled: savedState.filterPhaseColourSystemProcessingEnabled?? "-1",
    filterPhaseColourSystemPausedOverride: savedState.filterPhaseColourSystemPausedOverride?? "-1",

filterPhaseColourId: savedState.filterPhaseColourId !== undefined
  ? Number(savedState.filterPhaseColourId)
  : -1,
  }, () => {
    this.props.getStudies(
      this.state.stimsPerPage,
      this.state.pageNum,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride

    );
  });

  this.props.getTypes();
}

saveFiltersToSession = () => {
  sessionStorage.setItem(
    "dashboardFilters",
    JSON.stringify({
      stimsPerPage: this.state.stimsPerPage,
      pageNum: this.state.pageNum,
      orderBy: this.state.orderBy,
      filterName: this.state.filterName,
      filterLive: this.state.filterLive,
      isCompleted: this.state.isCompleted,
      filterMediaId: this.state.filterMediaId,
      filterEnvironmentId: this.state.filterEnvironmentId,
      showMyStudies: this.state.showMyStudies,
      showFilter: this.state.showFilter,
      filterPhaseId: this.state.filterPhaseId,
      filterPhaseColourId: this.state.filterPhaseColourId,
      filterPhaseColourSystemProcessingEnabled: this.state.filterPhaseColourSystemProcessingEnabled,
      filterPhaseColourSystemPausedOverride: this.state.filterPhaseColourSystemPausedOverride,

    })
  );
};


  onCreateStudyClick = () => {
    this.props.history.push(`/create-study`);
  };

  handlepageNumChange = (event, newPage) => {
    if (newPage) {
      this.setState({ pageNum: newPage },  this.saveFiltersToSession);
      this.props.getStudies(
        parseInt(this.state.stimsPerPage),
        parseInt(newPage),
        this.state.orderBy,
        this.state.filterName,
        this.state.filterLive,
        this.state.isCompleted,
        this.state.filterMediaId,
        this.state.filterEnvironmentId,
        this.getOwnerId(),
        this.state.filterPhaseId,
        this.state.filterPhaseColourId,
        this.state.filterPhaseColourSystemProcessingEnabled,
        this.state.filterPhaseColourSystemPausedOverride


      );
    }
  };

  handleStimsPerPageChange = (event) => {
    this.setState({ stimsPerPage: event.target.value, pageNum: 1 }, this.saveFiltersToSession);
    this.props.getStudies(
      event.target.value,
      1,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride


    );
  };

handleSortChange = (orderBy) => {
  this.setState({ orderBy }, this.saveFiltersToSession);
  this.props.getStudies(
    parseInt(this.state.stimsPerPage),
    parseInt(this.state.pageNum),
    orderBy,
    this.state.filterName,
    this.state.filterLive,
    this.state.isCompleted,
    this.state.filterMediaId,
    this.state.filterEnvironmentId,
    this.getOwnerId(),
    this.state.filterPhaseId,
    this.state.filterPhaseColourId,
    this.state.filterPhaseColourSystemProcessingEnabled,
    this.state.filterPhaseColourSystemPausedOverride
  );
};


handleSearchChange = (filterName) => {
  this.setState({ filterName }, this.saveFiltersToSession);
  clearTimeout(this.myTimer);
  this.myTimer = setTimeout(() => {
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );
  }, 500);
};


  handleFilterLiveChange = (filterLive) => {
    this.setState({ filterLive }, this.saveFiltersToSession);
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      this.state.filterName,
      filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride

    );
  };

  handleIsCompletedChange = (filterIsCompleted) => {
    this.setState({ isCompleted: filterIsCompleted }, this.saveFiltersToSession);
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      filterIsCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );
  };

  handlefilterMediaChange = (mediaCode) => {
    console.log(mediaCode);
    this.setState({ filterMediaId: mediaCode }, this.saveFiltersToSession);
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      mediaCode,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );
  };

  handlefilterEnvironmentChange = (environmentCode) => {
    this.setState({ filterEnvironmentId: environmentCode }, this.saveFiltersToSession);
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      environmentCode,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );
  };
handleShowMyStudiesChange = () => {
  const newValue = !this.state.showMyStudies;
   this.setState({ showMyStudies: newValue }, () => {
    this.saveFiltersToSession();
    this.props.getStudies(
      parseInt(this.state.stimsPerPage),
      1,
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      newValue ? this.props.accountData?.user_id : null,
      this.state.filterPhaseId, 
      this.state.filterPhaseColourId ,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );
  });
};

handleSelectAllStudies = async (checked) => {
  if (!checked) {
    this.setState({
      selectedStudies: [],
      selectAllChecked: false,
      selectAllLoading: false,
    });
    return;
  }

  this.setState({
    selectAllChecked: true,
    selectAllLoading: true,
  });

  try {
    const studyIds = await this.props.getAllFilteredStudyIds(
      parseInt(this.state.stimsPerPage, 10),
      this.state.orderBy,
      this.state.filterName,
      this.state.filterLive,
      this.state.isCompleted,
      this.state.filterMediaId,
      this.state.filterEnvironmentId,
      this.getOwnerId(),
      this.state.filterPhaseId,
      this.state.filterPhaseColourId,
      this.state.filterPhaseColourSystemProcessingEnabled,
      this.state.filterPhaseColourSystemPausedOverride
    );

    this.setState({
      selectedStudies: Array.isArray(studyIds) ? studyIds : [],
      selectAllChecked: true,
      selectAllLoading: false,
    });
  } catch (err) {
    this.setState({
      selectAllChecked: false,
      selectAllLoading: false,
    });
    console.error("Failed to select all filtered studies:", err);
  }
};

getOwnerId = () => {
  return this.state.showMyStudies ? this.props.accountData?.user_id : null;
};

getCurrentPageStudyIds = () => {
  const studies = this.getAllStudiesFromProps();
  return (studies || [])
    .map((s) => Number(s.study_id))
    .filter(Boolean);
};

isAllCurrentPageSelected = () => {
  if (this.state.selectAllChecked) return true;

  const currentPageIds = this.getCurrentPageStudyIds();
  const { selectedStudies } = this.state;

  if (!currentPageIds.length) return false;

  return currentPageIds.every((id) => selectedStudies.includes(id));
};

isSomeCurrentPageSelected = () => {
  if (this.state.selectAllChecked) return false;

  const currentPageIds = this.getCurrentPageStudyIds();
  const { selectedStudies } = this.state;

  if (!currentPageIds.length) return false;

  const selectedOnPage = currentPageIds.filter((id) =>
    selectedStudies.includes(id)
  );

  return selectedOnPage.length > 0 && selectedOnPage.length < currentPageIds.length;
};

handleStudiesSelection = (selectedStudies) => {
  this.setState({
    selectedStudies: Array.isArray(selectedStudies) ? selectedStudies : [],
    selectAllChecked: false,
  });
};

openActionsMenu = (e) => {
  this.setState({ actionsAnchorEl: e.currentTarget });
};

closeActionsMenu = () => {
  this.setState({ actionsAnchorEl: null });
};

handleBulkSystemCheckRequest = (enabled) => {
  const { selectedStudies } = this.state;
  if (!selectedStudies.length) return;

  const studies = this.getAllStudiesFromProps();

  const byId = new Map((studies || []).map((s) => [Number(s.study_id), s]));

  const isEnabledNow = (id) => {
    const s = byId.get(Number(id));
    return typeof s?.phase_colour_system_processing_enabled === "boolean"
      ? s.phase_colour_system_processing_enabled
      : false;
  };

  const skippedIds = [];
  const toUpdateIds = [];

  for (const id of selectedStudies) {
    if (isEnabledNow(id) === !!enabled) skippedIds.push(id);
    else toUpdateIds.push(id);
  }

  const toLabel = (id) => ({
    id: Number(id),
    name: this.getStudyNameById(id, byId),
  });

  const skippedStudies = skippedIds.map(toLabel);
  const updatedStudies = toUpdateIds.map(toLabel);

  //open confirmation pop up no api call yet
  this.openBulkConfirmDialog({
    enabled: !!enabled,
    toUpdateIds,
    skippedStudies,
    updatedStudies,
  });
};

handleBulkQualityActionRequest = ({ action, enabled }) => {
  const { selectedStudies } = this.state;
  if (!selectedStudies.length) return;

  const studies = this.getAllStudiesFromProps();
  const byId = new Map((studies || []).map((s) => [Number(s.study_id), s]));

  const isEnabledNow = (id) => {
    const s = byId.get(Number(id));

    if (action === "update_qualitychecks_enabled") {
      return typeof s?.phase_colour_system_processing_enabled === "boolean"
        ? s.phase_colour_system_processing_enabled
        : false;
    }

    if (action === "update_qualitychecks_override") {
      return typeof s?.phase_colour_system_paused_override === "boolean"
        ? s.phase_colour_system_paused_override
        : false;
    }

    return false;
  };

  const skippedIds = [];
  const toUpdateIds = [];

  for (const id of selectedStudies) {
    if (isEnabledNow(id) === !!enabled) skippedIds.push(id);
    else toUpdateIds.push(id);
  }

  const toLabel = (id) => ({
    id: Number(id),
    name: this.getStudyNameById(id, byId),
  });

  const skippedStudies = skippedIds.map(toLabel);
  const updatedStudies = toUpdateIds.map(toLabel);

  this.openBulkConfirmDialog({
    action,
    enabled: !!enabled,
    toUpdateIds,
    skippedStudies,
    updatedStudies,
  });
};

//pause override bulk handler
handleBulkPauseOverrideRequest = (enabled) => {
  this.handleBulkQualityActionRequest({
    action: "update_qualitychecks_override",
    enabled,
  });
};


getAllStudiesFromProps = () => {
  return (
    this.props.fetchAllStudysInfo?.data ||
    this.props.studyData ||
    this.props.fetchAllStudysInfo?.studies ||
    []
  );
};

getStudyNameById = (id, byId) => {
  const s = byId.get(Number(id));
  return s?.name || `Study ${id}`;
};

confirmBulkSystemCheck = async () => {
  const p = this.state.bulkConfirm;
  if (!p) return;

  const { toUpdateIds = [], enabled } = p;

  this.setState({ bulkSubmitting: true });

  try {
    if (toUpdateIds.length) {
     await this.props.bulkToggleQualityChecks(toUpdateIds, enabled, p.action);


      await this.props.getStudies(
        parseInt(this.state.stimsPerPage, 10),
        parseInt(this.state.pageNum, 10),
        this.state.orderBy,
        this.state.filterName,
        this.state.filterLive,
        this.state.isCompleted,
        this.state.filterMediaId,
        this.state.filterEnvironmentId,
        this.getOwnerId(),
        this.state.filterPhaseId,
        this.state.filterPhaseColourId,
        this.state.filterPhaseColourSystemProcessingEnabled,
        this.state.filterPhaseColourSystemPausedOverride
      );
    }

      this.setState({
      bulkConfirmOpen: false, 
  });
  } catch (err) {
    this.setState({ bulkSubmitting: false });
    console.error("Bulk system check failed:", err);
  }
};


openBulkConfirmDialog = (payload) => {
  this.setState({
    bulkConfirmOpen: true,
    bulkConfirm: payload,
    actionsAnchorEl: null,
  });
};

closeBulkConfirmDialog = () => {
  this.setState({
    bulkConfirmOpen: false,
  });
};


handleBulkConfirmExited = () => {
  this.setState({
    bulkConfirm: null,
    bulkSubmitting: false,
  });
};

  render() {
    const { loading, environmentTypes, mediaTypes, typesLoading } = this.props;

    return (
      <React.Fragment>
        <div className="dashboard">
          <Paper  elevation={0} style={{ borderRadius: 16, paddingBottom: 16, overflow: "visible", }}>
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    gap: 24,
  }}
>
  {/*search box */}
<TextField
  autoFocus
  onChange={(e) => this.handleSearchChange(e.target.value)}
  value={this.state.filterName}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
    ),
  }}
  label="Search studies..."
  variant="outlined"
  sx={{
    "& .MuiOutlinedInput-root": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    "& .MuiOutlinedInput-input": {
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  }}
/>


<div style={{ display: "flex", alignItems: "center", gap: 24 }}>
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <input
      type="checkbox"
      id="ShowMyStudies"
      checked={this.state.showMyStudies}
      onChange={this.handleShowMyStudiesChange}
      style={{
        width: "16px",
        height: "16px",
        visibility: "visible",
        display: "inline-block",
        cursor: "pointer",
      }}
    />
    <span
      style={{
        fontSize: "0.875rem",
        color: "#637381",
        fontWeight: 500,
      }}
    >
      Show My Studies
    </span>
  </div>

  {/*create study */}
  <Button
    className="button-primary"
    size="small"
    startIcon={<AddIcon />}
    onClick={this.onCreateStudyClick}
    data-testid="createStudy"
    title="Creates new study."
  >
    Create Study
  </Button>

  {/*actions dropdown*/}
<Button
  variant="contained"
  size="small"
  endIcon={<ExpandMoreIcon />}
  className={`button-secondary ${
    !this.state.selectedStudies?.length ? "disabled" : ""
  }`}
  disabled={!this.state.selectedStudies?.length}
  onClick={this.openActionsMenu}
  title={
    this.state.selectedStudies?.length
      ? "Bulk actions for selected studies"
      : "Select at least one study"
  }
>
  Actions
</Button>

  <Menu
    anchorEl={this.state.actionsAnchorEl}
    open={!!this.state.actionsAnchorEl}
    onClose={this.closeActionsMenu}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
  >

<MenuItem
  onClick={(e) => {
    e.stopPropagation();
    this.setState({ actionsAnchorEl: null }, () => {
      this.handleBulkSystemCheckRequest(true);
    });
  }}
>
  Enable quality check
</MenuItem>

<MenuItem
  onClick={(e) => {
    e.stopPropagation();
    this.setState({ actionsAnchorEl: null }, () => {
      this.handleBulkSystemCheckRequest(false);
    });
  }}
>
  Disable quality check
</MenuItem>

<Divider />

<MenuItem
  onClick={(e) => {
    e.stopPropagation();
    this.setState({ actionsAnchorEl: null }, () => {
      this.handleBulkPauseOverrideRequest(true);
    });
  }}
>
  Enable Override System Pause
</MenuItem>

<MenuItem
  onClick={(e) => {
    e.stopPropagation();
    this.setState({ actionsAnchorEl: null }, () => {
      this.handleBulkPauseOverrideRequest(false);
    });
  }}
>
  Disable Override System Pause
</MenuItem>

  </Menu>

  {/*filter icon */}
<Tooltip title="Filter studies" disableFocusListener disableTouchListener>
  <IconButton
    onClick={() =>
      this.setState(
        { showFilter: !this.state.showFilter },
        this.saveFiltersToSession
      )
    }
    aria-label="filter results"
    component="span"
  >
    <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
  </IconButton>
</Tooltip>
</div>

</div>

            {loading || typesLoading ? (
              <LoadingSpinner />
            ) : (
              <>
{this.state.showFilter && (
  <div style={{ padding: "0 16px 16px", display: "flex", flexDirection: "column", gap: 12 }}>
    {/* first row */}
    <div style={{ position: "relative", zIndex: 2 }}> 
    <FiltersRow
      columns={[
        {
          key: "live",
          label: "Live",
          minWidth: 140,
          control: (
            <CheckBoxStyled
              id="Live"
              checked={this.state.filterLive === "1"}
              handleClick={() =>
                this.handleFilterLiveChange(
                  this.state.filterLive === "1" ? "-1" : "1"
                )
              }
            />
          ),
        },
        {
          key: "completed",
          label: "Completed",
          minWidth: 160,
          control: (
            <CheckBoxStyled
              id="Completed"
              checked={this.state.isCompleted === "1"}
              handleClick={() =>
                this.handleIsCompletedChange(
                  this.state.isCompleted === "1" ? "-1" : "1"
                )
              }
            />
          ),
        },
        {
          key: "media",
          label: "Media",
          minWidth: 180,
          control: (
            <PrettyDropdown2
              options={mediaTypes}
              value={this.state.filterMediaId}
              onSelectItem={this.handlefilterMediaChange}
            />
          ),
        },
        {
          key: "environment",
          label: "Environment",
          minWidth: 200,
          control: (
            <PrettyDropdown2
              options={environmentTypes}
              value={this.state.filterEnvironmentId}
              onSelectItem={this.handlefilterEnvironmentChange}
            />
          ),
        },
        {
          key: "phase",
          label: "Phase",
          minWidth: 200,
          control: (
            <PrettyDropdown2
              options={[
                { description: "All", code: -1 },
                { description: "Definition", code: 1 },
                { description: "Setup", code: 2 },
                { description: "QA", code: 3 },
                { description: "Data Collection", code: 4 },
                { description: "Analysis", code: 5 },
                { description: "Completed", code: 6 },
              ]}
              value={this.state.filterPhaseId}
              onSelectItem={(code) => {
                const num = Number(code);
                this.setState({ filterPhaseId: num }, this.saveFiltersToSession);
                this.props.getStudies(
                  this.state.stimsPerPage,
                  1,
                  this.state.orderBy,
                  this.state.filterName,
                  this.state.filterLive,
                  this.state.isCompleted,
                  this.state.filterMediaId,
                  this.state.filterEnvironmentId,
                  this.getOwnerId(),
                  num,
                  this.state.filterPhaseColourId,
                  this.state.filterPhaseColourSystemProcessingEnabled,
                  this.state.filterPhaseColourSystemPausedOverride
                );
              }}
            />
          ),
        },
        {
          key: "phaseColour",
          label: "Phase Colour",
          minWidth: 200,
          control: (
            <PrettyDropdown2
              options={[
                { description: "All", code: -1 },
                { description: "Green", code: 1 },
                { description: "Amber", code: 2 },
                { description: "Red", code: 3 },
              ]}
              value={this.state.filterPhaseColourId}
              onSelectItem={(code) => {
                const num = Number(code);
                this.setState({ filterPhaseColourId: num }, this.saveFiltersToSession);
                this.props.getStudies(
                  this.state.stimsPerPage,
                  1,
                  this.state.orderBy,
                  this.state.filterName,
                  this.state.filterLive,
                  this.state.isCompleted,
                  this.state.filterMediaId,
                  this.state.filterEnvironmentId,
                  this.getOwnerId(),
                  this.state.filterPhaseId,
                  num,
                  this.state.filterPhaseColourSystemProcessingEnabled,
                  this.state.filterPhaseColourSystemPausedOverride
                );
              }}
            />
          ),
        },
      ]}
    />
</div>
    {/* second row */}
    <div style={{ position: "relative", zIndex: 1 }}> 
    <FiltersRow
      columns={[
        {
          key: "qualityCheck",
          label: "Quality Check",
          minWidth: 250,
          control: (
            <PrettyDropdown2
              options={[
                { description: "All", code: "-1" },
                { description: "Enabled", code: "1" },
                { description: "Disabled", code: "0" },
              ]}
              value={this.state.filterPhaseColourSystemProcessingEnabled}
              onSelectItem={(code) => {
                this.setState(
                  { filterPhaseColourSystemProcessingEnabled: String(code) },
                  this.saveFiltersToSession
                );

                this.props.getStudies(
                  this.state.stimsPerPage,
                  1,
                  this.state.orderBy,
                  this.state.filterName,
                  this.state.filterLive,
                  this.state.isCompleted,
                  this.state.filterMediaId,
                  this.state.filterEnvironmentId,
                  this.getOwnerId(),
                  this.state.filterPhaseId,
                  this.state.filterPhaseColourId,
                  String(code),
                  this.state.filterPhaseColourSystemPausedOverride
                );
              }}
            />
          ),
        },
        {
          key: "overridePause",
          label: "Override Pause",
          minWidth: 250,
          control: (
            <PrettyDropdown2
              options={[
                { description: "All", code: "-1" },
                { description: "Enabled", code: "1" },
                { description: "Disabled", code: "0" },
              ]}
              value={this.state.filterPhaseColourSystemPausedOverride}
              onSelectItem={(code) => {
                this.setState(
                  { filterPhaseColourSystemPausedOverride: String(code) },
                  this.saveFiltersToSession
                );

                this.props.getStudies(
                  this.state.stimsPerPage,
                  1,
                  this.state.orderBy,
                  this.state.filterName,
                  this.state.filterLive,
                  this.state.isCompleted,
                  this.state.filterMediaId,
                  this.state.filterEnvironmentId,
                  this.getOwnerId(),
                  this.state.filterPhaseId,
                  this.state.filterPhaseColourId,
                  this.state.filterPhaseColourSystemProcessingEnabled,
                  String(code)
                );
              }}
            />
          ),
        },
      ]}
    />
    </div>
  </div>
)}

                <div style={{ marginRight: 8 }}>
                  <TablePagination
                    rowsPerPage={this.state.stimsPerPage}
                    onRowsPerPageChange={this.handleStimsPerPageChange}
                    numberOfPages={this.props.fetchAllStudysInfo?.total_page_num ?? 1}
                    currentPage={this.props.fetchAllStudysInfo?.page_num ?? 1}
                    onPageChange={this.handlepageNumChange}
                  />
                </div>
                <DashboardTableContainer
                  handleSortChange={this.handleSortChange}
                  currentOrderBy={this.props.fetchAllStudysInfo?.order_by}
                  onStudiesSelection={this.handleStudiesSelection}
                  selectedStudies={this.state.selectedStudies}
                  onSelectAllStudies={this.handleSelectAllStudies}
                  allCurrentPageSelected={this.isAllCurrentPageSelected()}
                  someCurrentPageSelected={this.isSomeCurrentPageSelected()}
                  selectAllLoading={this.state.selectAllLoading}
                />

                <div style={{ marginTop: 16, marginRight: 8 }}>
                  <TablePagination
                    rowsPerPage={this.state.stimsPerPage}
                    onRowsPerPageChange={this.handleStimsPerPageChange}
                    numberOfPages={this.props.fetchAllStudysInfo?.total_page_num ?? 1}
                    currentPage={this.props.fetchAllStudysInfo?.page_num ?? 1}
                    onPageChange={this.handlepageNumChange}
                  />
                </div>
              </>
            )}

            <Dialog
  open={this.state.bulkConfirmOpen}
  onClose={this.closeBulkConfirmDialog}
  maxWidth="sm"
  fullWidth
  disableRestoreFocus
  disableEnforceFocus
  TransitionProps={{ onExited: this.handleBulkConfirmExited }}

>
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pr: 1,
    }}
  >
    <span>
{(() => {
  const p = this.state.bulkConfirm;
  if (!p) return "";

  const verb = p.enabled ? "Enable" : "Disable";

  if (p.action === "update_qualitychecks_enabled") return `${verb} system check`;
  if (p.action === "update_qualitychecks_override") return `${verb} Override System Pause`;

  return `${verb} action`;
})()}
    </span>

    <IconButton
      aria-label="close"
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeBulkConfirmDialog();
      }}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    {(() => {
      const p = this.state.bulkConfirm;
      if (!p) return null;

      const verb = p.enabled ? "enable" : "disable";

const actionLabel =
  p.action === "update_qualitychecks_enabled"
    ? "system check"
    : p.action === "update_qualitychecks_override"
    ? "Override System Pause"
    : "action";


      return (
        <>
          <Typography variant="body2" style={{ marginBottom: 12 }}>
            You are about to {verb} <b>{actionLabel}</b> for{" "}
            <b>{p.toUpdateIds?.length || 0}</b> study(ies).
          </Typography>

          {p.skippedStudies?.length ? (
            <>
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                These will be skipped (already {p.enabled ? "enabled" : "disabled"}):
              </Typography>

              <List dense>
                {p.skippedStudies.map(({ id, name }) => (
                  <ListItem key={`confirm-skipped-${id}`}>
                    {name} ({id})
                  </ListItem>
                ))}
              </List>

              <Divider style={{ margin: "12px 0" }} />
            </>
          ) : null}

          {p.updatedStudies?.length ? (
            <>
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                These will be updated:
              </Typography>

              <List dense>
                {p.updatedStudies.map(({ id, name }) => (
                  <ListItem key={`confirm-updated-${id}`}>
                    {name} ({id})
                  </ListItem>
                ))}
              </List>
            </>
          ) : (
            <Typography variant="body2">
              No updates are needed - everything selected is already{" "}
              {p.enabled ? "enabled" : "disabled"}.
            </Typography>
          )}
        </>
      );
    })()}
  </DialogContent>

  <DialogActions>
    <Button
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeBulkConfirmDialog();
      }}
      className="button-secondary"
      variant="outlined"
      size="small"
      disabled={this.state.bulkSubmitting}
    >
      Cancel
    </Button>

    <Button
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        this.confirmBulkSystemCheck();
      }}
      className="button-secondary"
      variant="contained"
      size="small"
      disabled={this.state.bulkSubmitting}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

          </Paper>
        </div>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  studyData: PropTypes.array,
  isStudyLive: PropTypes.bool,
  isStudyCompleted: PropTypes.bool,
  active_study_count: PropTypes.number,
  completed_study_count: PropTypes.number,
  accountData: PropTypes.object,
  isLive: PropTypes.func,
  isCompleted: PropTypes.func,
  media: PropTypes.func,
  environment: PropTypes.func,
  search: PropTypes.func,
  getStudies: PropTypes.func,
  loading: PropTypes.bool,
  onAscendingButtonClick: PropTypes.func,
};

export function addAllType(type = []) {
  return [{ description: "All", code: 0 }, ...type];
}
function mapStateToProps(state) {
  const loggedInUser = state.userData?.userData;
  return {
    studyData: state.studyData.studies,
    currentSort: state.studyData.currentSort,
    isStudyLive: state.studyData.isLive,
    accountData: loggedInUser,
    loggedInUser,
    value: state,
    loading: state.studyData.loading,
    openNewStudyModal: state.studyData.openNewStudyModal,
    environmentLoading: state.studyData.environmentLoading,
    environmentData: state.studyData.environmentData,
    modalOpen: state.studyData.openNewStudyModal,
    mediaData: state.studyData.mediaData,
    studyTypes: state.studyData.studyTypes,
    environmentTypes: addAllType(state.stimsReducer.environmentTypes),
    mediaTypes: addAllType(state.stimsReducer.mediaTypes),
    studyTypesData: state.stimsReducer.studyTypes,
    typesLoading: state.stimsReducer.typesLoading,
    languageTypes: state.studyData.languageTypes,
    fetchAllStudysInfo: state.studyData.fetchAllStudysInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    media: (media) => dispatch(dashboardOperations.setMediaFilter(media)),
    environment: (environment) =>
      dispatch(dashboardOperations.setEnvironmentFilter(environment)),
    getStudies: (
      stimsPerPage,
      pageNum,
      orderBy,
      filterName,
      filterLive,
      filterIsCompleted,
      mediaId,
      filter_environment_id,
      owner_id,
      filterPhaseId,    
      filterPhaseColourId ,
      filterPhaseColourSystemProcessingEnabled,
      filterPhaseColourSystemPausedOverride
 
    ) =>
      dispatch(
        dashboardOperations.getStudyData(
          stimsPerPage,
          pageNum,
          orderBy,
          filterName,
          filterLive,
          filterIsCompleted,
          mediaId,
          filter_environment_id,
          owner_id,
          filterPhaseId, 
          filterPhaseColourId,
          filterPhaseColourSystemProcessingEnabled,
          filterPhaseColourSystemPausedOverride
 
        )
      ),
    getTypes: () => dispatch(stimsOperations.getTypes()),
    fetchStudiesBegin: () => dispatch(dashboardOperations.fetchStudiesBegin()),
    bulkToggleQualityChecks: (studyIds, enabled, action) =>
    dispatch(dashboardOperations.bulkToggleQualityChecks(studyIds, enabled, action)),

       getAllFilteredStudyIds: (
      studiesPerPage,
      orderBy,
      filterName,
      filterLive,
      filterIsCompleted,
      mediaId,
      environmentId,
      owner_id,
      filterPhaseId,
      filterPhaseColourId,
      filterPhaseColourSystemProcessingEnabled,
      filterPhaseColourSystemPausedOverride
    ) =>
      dispatch(
        dashboardOperations.getAllFilteredStudyIds(
          studiesPerPage,
          orderBy,
          filterName,
          filterLive,
          filterIsCompleted,
          mediaId,
          environmentId,
          owner_id,
          filterPhaseId,
          filterPhaseColourId,
          filterPhaseColourSystemProcessingEnabled,
          filterPhaseColourSystemPausedOverride
        )
      ),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
